import React from 'react'
import './LoginPage.css'
import Navbar from './Navbar'
import Main from './Main'
import Footer from './Footer'

function LoginPage() {
  return (
    <>
    <Navbar/>
    <Main/>
    <Footer/>
    </>
  )
}

export default LoginPage